export default "__VITE_ASSET__9b5207dd__"